import React, { useEffect, useMemo, useState } from "react";
import DataTable from "components/datatable/DataTable";
import DataPagination from "./DataPagination";
import DataSearchCard from "./DataSearchCard";
import useAxiosFunction from "hooks/useAxiosFunction";
import useMsgBox from "hooks/useMsgBox";
import DataToolbar from "./DataToolbar";
import PopupDialog from "components/dialog/PopupDialog";
import MyForm from "components/form-elements/MyForm";
import usePDFRenderer from "hooks/usePDFRenderer";
import PDFTable from "components/datapdf/PDFTable";
import useXLSExport from "hooks/useXLSExport";
import MyFormEditable from "components/form-elements/MyFormEditable";
import DataDetail from "components/datatable/DataDetail";

const DataList = (props) => {
  const [saveXLS] = useXLSExport();
  const [getViewer, toggleViewer] = usePDFRenderer();
  const [showMsg, confirmMsg] = useMsgBox();
  let {
    dlist,
    reload,
    delconfig = null,
    editconfig = null,
    activateconfig = null,
    coltype,
    toolbar,
    addconfig = null,
    pdflist = null,
    pdfconfig = {},
    detailconfig,
    xlslist,
    title,
    ...rest
  } = props;
  const url = dlist?.url;
  const { usepagination = true, ...restdlist } = dlist;
  const activePdfList = pdflist === false ? null : pdflist || {};
  const activeXlsList = xlslist === false ? null : xlslist || {};
  const [page, setPage] = useState(1);
  const [sortCol, setSortCol] = useState("");
  const [keyword, setKeyword] = useState({});
  const [data, error, loading, axiosFetch] = useAxiosFunction();
  const [, errorpdf, loadingpdf, axiosFetchPDF] = useAxiosFunction();
  const [respax, errax, loadingax, fetchax] = useAxiosFunction();
  const [intReload, setIntReload] = useState(0);
  const [pdfSnapshot, setPdfSnapshot] = useState([]);
  const [pdfRenderKey, setPdfRenderKey] = useState(0);
  const [pdfBusy, setPdfBusy] = useState(false);
  const [displayError, setDisplayError] = useState("");

  const [popupAdd, setPopupAdd] = useState(false);
  const togglePopupAdd = () => setPopupAdd(!popupAdd);

  const [itemToEdit, setItemToEdit] = useState({});
  const [popupEdit, setPopupEdit] = useState(false);
  const togglePopupEdit = () => setPopupEdit(!popupEdit);

  const [itemToDelete, setItemToDelete] = useState(null);
  const [popupDelete, setPopupDelete] = useState(false);
  const togglePopupDelete = () => setPopupDelete(!popupDelete);

  const [id_detail, setIDDetail] = useState("");
  const [popupDetil, setPopupDetil] = useState(false);
  const togglePopupDetil = () => setPopupDetil(!popupDetil);
  const onCloseDetil = () => {
    const { onClose = (itm) => {}, ...rest } = detailconfig;
    setIDDetail("");
    onClose();
    togglePopupDetil();
    if (detailconfig?.reloadOnClose) {
      setIntReload(intReload + 1);
    }
  };

  const buildHiddenFilter = () => {
    let hiddenfilter = {};
    dlist?.filter?.forEach((element) => {
      if (element.dtype === "hidden") {
        hiddenfilter[element.name] = element.value;
      }
    });
    return hiddenfilter;
  };

  const refetch = () => {
    const hiddenfilter = buildHiddenFilter();
    axiosFetch({
      url: url,
      auth: true,
      timeout: 30000,
      params: { page: page, sort: sortCol, ...hiddenfilter, ...keyword },
    });
  };
  const adaptListResponse = (resp) => {
    const adapter = dlist?.adapter;
    if (typeof adapter !== "function") {
      return {
        data: resp?.data,
        page: resp?.page,
        usepagination,
      };
    }
    const adapted = adapter(resp) ?? {};
    return {
      data: adapted?.data ?? resp?.data,
      page: adapted?.page ?? resp?.page,
      usepagination: adapted?.usepagination ?? usepagination,
    };
  };
  const onCancelAdd = () => {
    const { onCancel = () => {}, ...rest } = addconfig;
    onCancel();
    togglePopupAdd();
  };

  const onSuccessSave = () => {
    const { onSuccess = () => {}, ...rest } = addconfig;
    setIntReload(intReload + 1);
    onSuccess();
    togglePopupAdd();
  };

  const onSuccessEdit = () => {
    const { onSuccess = () => {}, ...rest } = editconfig;
    setItemToEdit({});
    setIntReload(intReload + 1);
    onSuccess();
    togglePopupEdit();
  };

  const onCancelEdit = () => {
    const { onCancel = () => {}, ...rest } = editconfig;
    setItemToEdit({});
    //setIntReload(intReload + 1)
    onCancel();
    togglePopupEdit();
  };

  //fungsi default utk merender aksi
  const renderAction = (val, col, item, coltype) => {
    //buat action toggleactivate
    let activate = "";
    if (activateconfig) {
      const {
        activateHandle,
        url,
        cellname,
        cellid,
        labelactivate = "Aktifkan",
        labelinactivate = "Non-aktifkan",
        cellactivate,
        isAllow = (item) => true,
      } = activateconfig;
      const caption = item[cellactivate] ? labelinactivate : labelactivate;
      const icon = item[cellactivate]
        ? "fa fa-window-close"
        : "fa fa-check-square";
      if (activateHandle && isAllow(item)) {
        activate = (
          <>
            <a
              href="#"
              onClick={(event) => {
                event.preventDefault();
                activateHandle(item);
              }}
              className="btn btn-danger btn-xs"
              title={caption}
            >
              <i className={icon}></i>
            </a>
            &nbsp;
          </>
        );
      } else if (url && cellid && isAllow(item)) {
        activate = (
          <>
            <a
              href="#"
              onClick={(event) => {
                event.preventDefault();
                confirmToggleActive(item);
              }}
              className="btn btn-danger btn-xs"
              title={caption}
            >
              <i className={icon}></i>
            </a>
            &nbsp;
          </>
        );
      }
    }

    //buat action delete
    let del = "";
    if (delconfig) {
      const {
        deleteHandle,
        url,
        cellname,
        cellid,
        isAllow = (item) => true,
      } = delconfig;
      if (deleteHandle && isAllow(item)) {
        del = (
          <>
            <a
              href="#"
              onClick={(event) => {
                event.preventDefault();
                deleteHandle(item);
              }}
              className="btn btn-danger btn-xs"
              title="Hapus"
            >
              <i className="fa  fa-trash"></i>
            </a>
            &nbsp;
          </>
        );
      } else if (url && cellid && isAllow(item)) {
        del = (
          <>
            <a
              href="#"
              onClick={(event) => {
                event.preventDefault();
                confirmDelete(item);
              }}
              className="btn btn-danger btn-xs"
              title="Hapus"
            >
              <i className="fa  fa-trash"></i>
            </a>
            &nbsp;
          </>
        );
      }
    }

    //buat detail
    //todo
    let detail = "";
    if (detailconfig) {
      const {
        isAllow = (item) => true,
        tooltip = "Detail",
        icon = "fa-search",
        btnClass = "btn btn-primary btn-xs",
      } = detailconfig;
      if (isAllow(item)) {
        detail = (
          <>
            <a
              href="#"
              onClick={(event) => {
                event.preventDefault();
                showDetail(item);
              }}
              className={btnClass}
              title={tooltip}
            >
              <i className={"fa  " + icon}></i>
            </a>
            &nbsp;
          </>
        );
      }
    }

    //buat edit
    //todo
    let edit = "";
    if (editconfig) {
      const { editHandle, url, cellid, isAllow = (item) => true } = editconfig;
      if (editHandle && isAllow(item)) {
        edit = (
          <>
            <a
              href="#"
              onClick={(event) => {
                event.preventDefault();
                editHandle(item);
              }}
              className="btn btn-primary btn-xs"
              title="Edit"
            >
              <i className="fa  fa-pencil-alt"></i>
            </a>
            &nbsp;
          </>
        );
      } else if (url && cellid && isAllow(item)) {
        edit = (
          <>
            <a
              href="#"
              onClick={(event) => {
                event.preventDefault();
                showEdit(item);
              }}
              className="btn btn-primary btn-xs"
              title="Edit"
            >
              <i className="fa  fa-pencil-alt"></i>
            </a>
            &nbsp;
          </>
        );
      }
    }

    //tambahkan custom function
    let ext = "";
    if (dlist?.render_action_extension) {
      const { render_action_extension, ...rest } = dlist;
      ext = render_action_extension(val, col, item, coltype);
    }

    return (
      <>
        {detail}
        {edit}
        {del}
        {activate}
        {ext}
      </>
    );
  };

  //Fungsi untuk delete
  const confirmDelete = async (item) => {
    setItemToDelete(item);
    togglePopupDelete();
  };

  const doDelete = async () => {
    if (!itemToDelete || !delconfig) {
      return;
    }
    const { url, cellid } = delconfig;
    const delurl = itemToDelete?.[cellid]
      ? url + "/" + itemToDelete[cellid]
      : "";
    const hasil = await fetchax({ method: "DELETE", url: delurl, auth: true });
    if (hasil?.data?.success === true) {
      togglePopupDelete();
      setItemToDelete(null);
      showMsg("Informasi", "Data berhasil dihapus.");
      setIntReload(intReload + 1);
    } else if (hasil?.data?.success === false) {
      showMsg("Error", hasil?.message);
    } else {
      showMsg("Error", "Tidak terhubung ke server!");
    }
  };

  //Fungsi untuk toggle active
  const confirmToggleActive = async (item) => {
    const {
      url,
      cellname,
      cellid,
      cellactivate,
      cfmactivate = "mengaktifkan",
      cfminactivate = "menonaktifkan",
      infoactivate = "diaktifkan",
      infoinactivate = "dinonaktifkan",
    } = activateconfig;
    const dataname = cellname && item[cellname] ? item[cellname] : "ini";
    const acturl = item[cellid]
      ? url + "/" + item[cellid] + "/toggle-active"
      : "";
    const cfmMsg = item[cellactivate] ? cfminactivate : cfmactivate;
    const infoMsg = item[cellactivate] ? infoinactivate : infoactivate;

    const res = await confirmMsg(
      "Konfirmasi",
      "Apakah Anda yakin akan " + cfmMsg + " data " + dataname + "?",
    );
    if (res === true) {
      const hasil = await fetchax({ method: "GET", url: acturl, auth: true });
      if (hasil?.data?.success === true) {
        showMsg("Informasi", "Data berhasil " + infoMsg);
        setIntReload(intReload + 1);
      } else if (hasil?.data?.success === false) {
        showMsg("Error", hasil?.message);
      } else {
        showMsg("Error", "Tidak terhubung ke server!");
      }
    }
  };

  const cekDefaultColumns = () => {
    //Jika tidak ada coltype action, maka tambhakan
    //Jika sudah ada, cek ada tidaknya renderFunc, jika tidak ada maka tambahkan
    if (coltype?.action) {
      let actioncfg = coltype.action;
      if (!actioncfg?.renderFunc) {
        //coltype.action = { ...coltype.action, renderFunc: renderAction }
        const actcfg = { ...actioncfg, renderFunc: renderAction };
        coltype = { ...coltype, action: actcfg };
      }
    } else {
      coltype = {
        ...coltype,
        action: { label: "Aksi", align: "center", renderFunc: renderAction },
      };
    }

    //Jika tidak ada coltype no, maka tambahkan
    if (!coltype?.no) {
      coltype = { ...coltype, no: { label: "No", width: 5, align: "center" } };
    }
  };
  cekDefaultColumns();

  const RenderFormAdd = () => {
    return (
      addconfig && (
        <PopupDialog
          size={addconfig?.size ? addconfig.size : "lg"}
          title={""}
          show={popupAdd}
          closeHandle={togglePopupAdd}
          allowClose={false}
        >
          <MyForm
            coltype={coltype}
            {...addconfig}
            onSuccess={onSuccessSave}
            //onError={() => togglePopupAdd()}
            onCancel={onCancelAdd}
          />
        </PopupDialog>
      )
    );
  };
  const formAdd = RenderFormAdd();

  /*const RenderFormEdit = () => {
        return editconfig && <PopupDialog size="lg" title={""} show={popupEdit} closeHandle={togglePopupEdit} allowClose={false}>
            <MyForm
                {...editconfig}
                onSuccess={onSuccessEdit}
                //onError={() => togglePopupAdd()}
                onCancel={togglePopupEdit}
                coltype={coltype}
            />
        </PopupDialog>
    }
    const formEdit = RenderFormEdit()*/

  const showEdit = async (item) => {
    const {
      url,
      urlitem,
      cellid,
      editid,
      columns,
      onInitialize = (itm) => {},
      showEditExtension = () => {},
      normalizeItem = (itm) => itm,
      ...rest
    } = editconfig;
    //await showEditExtension(item)
    const itemurl = item[cellid] ? urlitem + "/" + item[cellid] : "";
    const hasil = await fetchax({ method: "GET", url: itemurl, auth: true });

    if (hasil?.data) {
      const normalized = normalizeItem(hasil?.data);
      setItemToEdit(normalized);
      onInitialize(normalized);
      togglePopupEdit();
    } else {
      showMsg("Error", "Data tidak tersedia!");
    }
  };

  const showDetail = async (item) => {
    const { cellid, onInitialize = (itm) => {}, ...rest } = detailconfig;
    setIDDetail(item[cellid]);
    onInitialize(item);
    togglePopupDetil();
  };

  const showPDF = async () => {
    setPdfBusy(true);
    await new Promise((resolve) => setTimeout(resolve, 50));
    const hiddenfilter = buildHiddenFilter();
    const ret = await axiosFetchPDF({
      url: url,
      auth: true,
      params: { page: -1, sort: sortCol, ...hiddenfilter, ...keyword },
    });
    const adapted = adaptListResponse(ret);
    if (adapted?.data) {
      setPdfSnapshot(adapted.data);
      setPdfRenderKey(Date.now());
      toggleViewer();
      setTimeout(() => setPdfBusy(false), 1500);
    } else {
      setPdfBusy(false);
      showMsg("Error", ret?.message || "Data PDF tidak tersedia.");
    }
  };

  const exportXLS = async () => {
    const hiddenfilter = buildHiddenFilter();
    const ret = await axiosFetchPDF({
      url: url,
      auth: true,
      params: { page: -1, sort: sortCol, ...hiddenfilter, ...keyword },
    });
    const adapted = adaptListResponse(ret);
    if (adapted?.data) {
      saveXLS({
        title: title,
        data: adapted?.data,
        xlslist: activeXlsList,
        dlist: dlist,
        coltype: coltype,
        filter: { ...hiddenfilter, ...keyword },
      });
    } else {
      showMsg("Error", ret?.message || "Data XLS tidak tersedia.");
    }
  };

  const onFilterChange = (nextKeyword) => {
    setPage(1);
    setKeyword(nextKeyword || {});
    if (typeof dlist?.onFilterChange === "function") {
      dlist.onFilterChange(nextKeyword || {});
    }
  };

  const showAdd = () => {
    const { onInitialize = () => {}, ...rest } = addconfig;
    onInitialize();
    togglePopupAdd();
  };

  const cekDefaultToolbar = () => {
    if (addconfig) {
      toolbar = toolbar
        ? [
            {
              label: addconfig?.label_tool ? addconfig.label_tool : "Tambah",
              icon: "fa-plus",
              onClick: showAdd,
            },
            ...toolbar,
          ]
        : [
            {
              label: addconfig?.label_tool ? addconfig.label_tool : "Tambah",
              icon: "fa-plus",
              onClick: showAdd,
            },
          ];
    }

    if (activePdfList) {
      toolbar = toolbar
        ? [
            ...toolbar,
            {
              label: activePdfList?.label_tool
                ? activePdfList.label_tool
                : "PDF",
              icon: "fa-file-pdf",
              onClick: showPDF,
            },
          ]
        : [
            {
              label: activePdfList?.label_tool
                ? activePdfList.label_tool
                : "PDF",
              icon: "fa-file-pdf",
              onClick: showPDF,
            },
          ];
    }

    if (activeXlsList) {
      toolbar = toolbar
        ? [
            ...toolbar,
            {
              label: activeXlsList?.label_tool
                ? activeXlsList.label_tool
                : "XLS",
              icon: "fa-file-excel",
              onClick: exportXLS,
            },
          ]
        : [
            {
              label: activeXlsList?.label_tool
                ? activeXlsList.label_tool
                : "XLS",
              icon: "fa-file-excel",
              onClick: exportXLS,
            },
          ];
    }
  };
  cekDefaultToolbar();

  const hiddenFilterKey = useMemo(() => {
    const hidden =
      dlist?.filter
        ?.filter((f) => f?.dtype === "hidden")
        ?.map((f) => [f?.name ?? "", f?.value ?? null]) ?? [];
    return JSON.stringify(hidden);
  }, [dlist?.filter]);

  const searchCardKey = useMemo(() => {
    const filters =
      dlist?.filter?.map((f) => ({
        dtype: f?.dtype || "",
        name: f?.name || "",
        value: f?.value ?? "",
      })) ?? [];
    return JSON.stringify({ url, filters });
  }, [dlist?.filter, url]);

  useEffect(() => {
    setPage(1);
    setSortCol("");
    setKeyword({});
  }, [url, hiddenFilterKey]);

  useEffect(() => {
    refetch();
  }, [url, hiddenFilterKey, page, sortCol, keyword, reload, intReload]);

  useEffect(() => {
    if (loading || data || !error) {
      setDisplayError("");
      return undefined;
    }
    const timer = setTimeout(() => setDisplayError(error), 800);
    return () => clearTimeout(timer);
  }, [data, error, loading]);

  return (
    <>
      {dlist && (
        <div className="dataTables_wrapper dt-bootstrap4">
          {dlist?.filter && (
            <div className="row">
              <DataSearchCard
                key={searchCardKey}
                changeKeyword={onFilterChange}
                filter={dlist?.filter}
              />
            </div>
          )}
          {toolbar && (
            <div className="row">
              <DataToolbar tools={toolbar} />
            </div>
          )}
          {(() => {
            const adapted = adaptListResponse(data);
            const tableData = adapted?.data;
            const paging = adapted?.page;
            const showPagination = adapted?.usepagination;
            return (
              <>
                {loading && !data && (
                  <div className="col-12">
                    <div className="text-center text-muted py-4">
                      <i className="fas fa-spinner fa-spin mr-2"></i>
                      Memuat data...
                    </div>
                  </div>
                )}
                {loading && data && (
                  <div className="col-12">
                    <div className="alert alert-light border mb-2 py-2 text-muted">
                      <i className="fas fa-spinner fa-spin mr-2"></i>
                      Memuat ulang data...
                    </div>
                  </div>
                )}
                {!loading && displayError && !data && (
                  <div className="row">
                    <div className="col-12">
                      <div className="alert alert-danger mb-3">
                        Data gagal dimuat. {displayError}
                      </div>
                    </div>
                  </div>
                )}
                <div className="row">
                  {data && (
                    <DataTable
                      changeSort={setSortCol}
                      dlist={dlist}
                      coltype={coltype}
                      {...rest}
                      data={tableData}
                      paging={paging}
                    ></DataTable>
                  )}
                </div>
                {data && showPagination && (
                  <DataPagination changePage={setPage} paging={paging} />
                )}
              </>
            );
          })()}
        </div>
      )}

      {addconfig ? formAdd : ""}
      {editconfig && itemToEdit && (
        <PopupDialog
          size={editconfig?.size ? editconfig.size : "lg"}
          title={""}
          show={popupEdit}
          closeHandle={togglePopupEdit}
          allowClose={false}
        >
          <MyFormEditable
            coltype={coltype}
            {...editconfig}
            onSuccess={onSuccessEdit}
            defaultValue={itemToEdit}
            onCancel={onCancelEdit}
          />
        </PopupDialog>
      )}
      {detailconfig && id_detail !== "" && (
        <PopupDialog
          size={detailconfig?.size ? detailconfig.size : "lg"}
          title={""}
          show={popupDetil}
          closeHandle={onCloseDetil}
          allowClose={true}
          footerContent={
            typeof detailconfig?.footerContent === "function"
              ? detailconfig.footerContent({ idDetail: id_detail })
              : detailconfig?.footerContent
          }
        >
          <DataDetail
            coltype={coltype}
            {...detailconfig}
            id_detail={id_detail}
          />
        </PopupDialog>
      )}
      {delconfig && popupDelete && (
        <PopupDialog
          size="md"
          title="Konfirmasi Hapus"
          show={popupDelete}
          closeHandle={() => {
            setItemToDelete(null);
            togglePopupDelete();
          }}
          allowClose={true}
          closeLabel="Batal"
          doHandle={doDelete}
          doLabel={loadingax ? "Menghapus..." : "Hapus"}
          doDisabled={loadingax}
        >
          <p className="mb-0">
            Apakah Anda yakin akan menghapus data{" "}
            <strong>
              {itemToDelete?.[delconfig?.cellname]
                ? itemToDelete?.[delconfig?.cellname]
                : "ini"}
            </strong>
            ?
          </p>
        </PopupDialog>
      )}

      {activePdfList
        ? getViewer({
            title: title,
            orientation: activePdfList?.orientation,
            size: activePdfList?.size,
            pageStyle: activePdfList?.pageStyle,
            modalSize: activePdfList?.modalSize,
            content: (
              <PDFTable
                data={pdfSnapshot}
                pdflist={activePdfList}
                dlist={dlist}
                coltype={coltype}
                title={title}
                filter={{ ...buildHiddenFilter(), ...keyword }}
              ></PDFTable>
            ),
            viewerKey: pdfRenderKey,
            ...pdfconfig,
          })
        : ""}
      <PopupDialog
        size="sm"
        title="Menyiapkan PDF"
        show={pdfBusy || loadingpdf}
        closeHandle={() => {}}
        allowClose={false}
      >
        <div className="text-center p-3">
          <i className="fas fa-spinner fa-spin fa-2x mb-3"></i>
          <div>Mohon tunggu, PDF sedang disiapkan...</div>
        </div>
      </PopupDialog>
    </>
  );
};
DataList.defaultProps = {
  dlist: null,
  delconfig: null,
  addconfig: null,
  detailconfig: null,
  reload: 0,
};
export default DataList;
